import * as ObjectUtils from '@core/objectUtils'

export const sortableKeys = {
  dateCreated: ObjectUtils.keys.dateCreated,
  dateModified: ObjectUtils.keys.dateModified,
  datePublished: 'datePublished',
  name: ObjectUtils.keys.name,
  ownerName: 'owner_name',
  label: 'label',
  status: 'status',
}
